"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (_ref, Component) {
    var connectDropTarget = _ref.connectDropTarget,
        inList = _ref.inList;

    if (inList) return Component;
    return connectDropTarget(Component);
};


//////////////////
// WEBPACK FOOTER
// ./src/client/element/column/columnOnDropConnectDropTarget.js
// module id = 453
// module chunks = 0